import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import ride from './modules/ride';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    ride,
  },
  actions: {
    clear({ commit }) {
      commit('auth/clear');
      commit('ride/clear');

      localStorage.clear();
      sessionStorage.clear();
    },
  },
});
